export default "__VITE_ASSET__O3ZgbMQE__"